import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "cursor",
  "use": "cursor-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"cursor\"><path d=\"M12.849 24l-3.96-7.853L4 20.289V0l16 12.875-6.192 1.038 3.901 7.696L12.849 24zM9.55 13.021l4.194 8.3 1.264-.617-4.213-8.313 4.632-.749L6 4.083v11.984l3.55-3.046z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol